export const AppConfig = {
    MQTT_USERNAME: 'wifundity',
    MQTT_PASSWORD: 'WiFundity',
    MQTT_URL: 'wss://mosquitto.cloud.wifundity.com',
    API_URL: 'https://portal.cloud.wifundity.com',
    OPENVIDU_SERVER_URL: 'https://openvidu.cloud.wifundity.com',
    WIFUNDITY_NOTIFICATION: 'https://portal.cloud-si.wifundity.com/notification',
}